module.exports = __webpack_public_path__ + "img/dstv-error-fix-3.25d450c3.jpg";